/* @flow weak */
import * as actions from './actions';
import {Record} from '../transit';
import messages from './messages';

const State = Record({
    currentLocale: 'cs',
    defaultLocale: 'cs',
    initialNow: null,
    locales: ['cs', 'en'],
    messages: null,
    trans: messages
}, 'intl');

const intlReducer = (state = new State(), action) => {
    switch (action.type) {

        case actions.SET_CURRENT_LOCALE: {
            const { locale } = action.payload;
            return state.set('currentLocale', locale);
        }

        default:
            return state;

    }
};

export default intlReducer;



// WEBPACK FOOTER //
// ./src/common/intl/reducer.js